module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_10-8af779ec76103b6466834c4218435a35.svg";